export enum AccountOnboardingType {
  CLIENT = 'client',
  TRAINER = 'trainer',
  ORGANIZATION = 'organization',
  // F4: trainer/admin who is joining someone else's organization — waits for
  // an invitation, carries no role and no org of its own.
  MEMBER = 'member',
}
